
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/user-agreement",
      function () {
        return require("private-next-pages/us/user-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/user-agreement"])
      });
    }
  